export function startLoading(button?: HTMLElement | null) {
	if (!button) return;
	button.classList.add("is-loading");
}

export function stopLoading(button?: HTMLElement | null) {
	if (!button) return;
	button.classList.remove("is-loading");
}
